var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-startstop" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "block" }),
      _vm._v(" "),
      _vm._l(_vm.work_rows, function(row, row_index) {
        return _c("div", { key: row.id, staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "tile is-ancestor" },
            _vm._l(row, function(work, col_index) {
              return _c(
                "div",
                {
                  key: work,
                  staticClass: "tile is-parent is-3",
                  on: {
                    click: function($event) {
                      return _vm.select_work_clicked(row_index, col_index)
                    }
                  }
                },
                [
                  _c(
                    "article",
                    {
                      staticClass: "tile is-child notification is-success",
                      class: { "is-warning": _vm.index % 2 === 0 }
                    },
                    [_c("p", { staticClass: "title" }, [_vm._v(_vm._s(work))])]
                  )
                ]
              )
            }),
            0
          )
        ])
      }),
      _vm._v(" "),
      _c("b-loading", {
        staticStyle: { "background-color": "rgba(0, 0, 0, 0.8)" },
        attrs: { "is-full-page": true, "can-cancel": false },
        model: {
          value: _vm.isLoading,
          callback: function($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading"
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "title-bar" }, [
      _c("div", { staticClass: "hero-body" }, [
        _c("p", { staticClass: "title" }, [_vm._v("作業内容の選択")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("作業内容を選択してください")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ffc6446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ffc6446","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectWork.vue
// module id = 7rNS
// module chunks = 0